import React from 'react';
import { useParams } from 'react-router-dom';
import { TaxCertificationPage } from './TaxCertificationPage';
import { UUID } from '../../../types/shared/UUID';
import { useGetUserType } from 'components/accessControl/hooks/useGetUserType';

interface ITaxCertificationContainerParams {
  orderId: UUID;
}

export const TaxCertificationContainer: React.FC = () => {
  const { orderId } = useParams<ITaxCertificationContainerParams>();
  const userType = useGetUserType();

  return <TaxCertificationPage userType={userType} orderId={orderId} />;
};
